<!-- Modal -->
<div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div id="modito" class="modal-content">
            <div class="modal-header">
                <p style="font-weight: bold" class="modal-title" id="exampleModalLabel">Descripcion del gasto cod: [{{ codi_edit }}]</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
            </div>
            <div class="modal-body">
                <p style="color:dimgray; font-weight: bold;"> "{{ det_edit }}" </p>
                <p style="font-style: italic; font-weight: bold;">TOTAL: ${{ tot_edit }}</p>
            </div>
            <div class="modal-footer" class="col-lg-12">
                <div style="text-align: center;" id="modalesa">
                    <button data-dismiss="modal" (click)="enviarCodGasto()" routerLink="/verdetalles-pagos" type="button" class="btn btn-primary">VER DETALLADO</button> &nbsp;
                    <span>&nbsp;</span>
                    <button disabled="estadoElegido=='AUTORIZADO'" data-dismiss="modal" (click)="autorizarGasto()" routerLink="/vergastos-pagos" type="button" class="btn btn-success">AUTORIZAR</button>
                    <a type="button" target="_blank" routerLink="/print-gastos" class="btn btn-success btn-block" mat-button (click)="enviarCodGasto()" >IMPRIMIR GASTO {{ codi_edit }}</a>
                </div>
                <hr>
                <div id="modalnga" style="text-align: center; height: 60px;">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Volver</button>
                    <br>
                </div>

                <!-- 
                juan no quiere rechazar   
                <button data-dismiss="modal" (click)="rechazarGasto()" routerLink="/vergastos-pagos" type="button" class="btn btn-danger">RECHAZAR</button>
                -->
            </div>
        </div>
    </div>
</div>

<div class="animated fadeIn" id="todo">
    <div class="col-lg-12">

        <app-loading class="m-5" *ngIf="loading"></app-loading>
        <span id="titlee" style="font-weight: bolder;"> Listado de Gastos  <span *ngIf="estadoElegido=='PENDIENTE'" class="badge badge-pill badge-info"> - {{ noti }}  Gastos pendientes.. </span>
        </span>
        <br>
        <br>
        
        <td>
            <mat-radio-group class="example-radio-group" [(ngModel)]="estadoElegido">
                <mat-radio-button class="example-radio-button" *ngFor="let est of estados" [value]="est">
                    {{est}}S
                </mat-radio-button>
            </mat-radio-group>
            <button (click)="calculaUsuarios()" type="button" class="btn btn-secondary" mat-button> Aplicar filtro</button>
    
        </td>
        
        <hr>
        <!--
        <div class="form-group">
            <label for="inputcategoria">CATEGORÍA</label>
            <select placeholder="Seleccione.." [(ngModel)]="CATEGORIA" name="CATEGORIA" id="CATEGORIA" class="form-control">
              <option>VIAJE</option>
              <option>SECCIONAL</option>
              <option>OTROS</option>
            </select>
        </div>
        -->
        <div class="form-group">
            <label *ngIf="estadoElegido=='PENDIENTE' || estadoElegido=='AUTORIZADO'" for="inputcategoria">USUARIO</label>
            <select *ngIf="estadoElegido=='PENDIENTE'" placeholder="Seleccione.." [(ngModel)]="USER" name="USER" id="USER" class="form-control">
              <option *ngFor="let user of dataSource2.data" [ngValue]="user.ID">"{{ user.USUARIO }}", [{{ user.CANT }}] gastos pendientes de Autorización, TOTAL ${{user.TOTAL_AUTORIZAR | currency:"$"}} </option>
            </select>
            <select *ngIf="(estadoElegido=='AUTORIZADO')" placeholder="Seleccione.." [(ngModel)]="USER" name="USER" id="USER" class="form-control">
                <option *ngFor="let user of dataSource2.data" [ngValue]="user.ID">"{{ user.USUARIO }}", [{{ user.CANT }}] gastos autorizados TOTAL ${{user.TOTAL_AUTORIZAR | currency:"$"}} </option>
            </select>
            <label *ngIf="estadoElegido=='PENDIENTE' || estadoElegido=='AUTORIZADO'" for="inputcategoria">MOTIVO</label>
            <select [(ngModel)]="CATEGORIA" name="CATEGORIA" id="CATEGORIA" class="form-control" value="VIAJE">
                <option>VIAJE</option>
                <option>GASTOS OBRA SOCIAL</option>
            </select>

        </div>
        <!--
        <div class="form-group">
            <label for="inputcategoria">ESTADO</label>
            <select placeholder="Seleccione.." [(ngModel)]="EST" name="EST" id="EST" class="form-control">
              <option>PENDIENTE</option>
              <option>AUTORIZADO</option>
              <option>RECHAZADO</option>
            </select>
        </div>
        -->
        <button data-dismiss="modal" (click)="buscarFiltros()" type="button" class="btn btn-block btn-info">CONSULTAR</button>

        <div class="col-lg-12" id="grid" #TABLE>
            <mat-form-field>
                <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar..">
            </mat-form-field>

            <div class="example-container mat-elevation-z8">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Position Column -->
                    <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                        <td mat-cell *matCellDef="let element"> {{element.position}} </td>
                    </ng-container>
                    <ng-container matColumnDef="CODIGO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD_GASTO </th>
                        <td mat-cell *matCellDef="let element"> {{element.CODIGO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="USUARIO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                        <td mat-cell *matCellDef="let element"> {{element.USUARIO}} </td>
                    </ng-container>
                    <ng-container matColumnDef="SEC_DEL">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> SEC_DEL </th>
                        <td mat-cell *matCellDef="let element"> {{element.SEC_DEL}} </td>
                    </ng-container>
                    <ng-container matColumnDef="CATEGORIA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> MOTIVO </th>
                        <td mat-cell *matCellDef="let element"> {{element.CATEGORIA}} </td>
                    </ng-container>
                    <ng-container matColumnDef="DETALLE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> DETALLE </th>
                        <td style="font-style: italic; font-weight: bold;" mat-cell *matCellDef="let element"> {{element.DETALLE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="IMPORTE">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> TOTAL ($) </th>
                        <td style="font-weight: bold" mat-cell *matCellDef="let element"> ${{element.IMPORTE}} </td>
                    </ng-container>
                    <ng-container matColumnDef="OBSERVACIONES">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> OBSERVACIONES </th>
                        <td mat-cell *matCellDef="let element"> {{element.OBSERVACIONES}} </td>
                    </ng-container>
                    <ng-container matColumnDef="FECHA_MODIFICACION">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA-MODIF </th>
                        <td mat-cell *matCellDef="let element"> {{ element.FECHA_MODIFICACION | date:"dd/MM/yy" }} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row (click)="selectRow(row.CODIGO,row.DETALLE,row.IMPORTE)" data-toggle="modal" data-target="#exampleModal2" *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></tr>
                </table>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>

        </div>
    </div>
    <button class="btn-block" color="dark" mat-button (click)="exportAsExcel()" [disabled]="dataSource.data.length==0">Exportar a Excel</button>
    <button type="button" class="btn btn-secondary btn-block" mat-button routerLink="/home">Volver</button>
</div>